import type { ButtonHTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

function NavMenuIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={8}
      viewBox="0 0 12 8"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M1 1h10M1 4h10M1 7h10"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
      />
    </svg>
  )
}

function NavCloseIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M1.2 1.2 10.8 10.8M10.8 1.2 1.2 10.8"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  )
}

export function NavMobileMenuButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      className={cn(
        // Primary button styling (bg-primary + dark primary-foreground icon +
        // primary-hover), kept circular. Size comes from --nav-mobile-menu-size
        // (see .nav-mobile-menu) so it stays the single source of truth.
        'nav-mobile-menu inline-flex shrink-0 items-center justify-center rounded-full border-0 bg-primary p-0 text-primary-foreground transition-colors hover:bg-[var(--primary-hover)]',
        className
      )}
      {...props}
    >
      <NavMenuIcon className="nav-mobile-menu__icon" />
    </button>
  )
}

export function NavMobileCloseButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" className={cn('nav-mobile-icon-btn nav-mobile-close', className)} {...props}>
      <NavCloseIcon className="nav-mobile-close__icon" />
    </button>
  )
}
